import React from "react";
import { P } from "common/P/P";

export interface TimelineItemProps {
	date: string;
	person: string;
	positionName: string;
	action: string;
	status: "accepted" | "confirmed" | "rejected" | "haveTo" | "archieve";
	documents?: string[];
	note?: string;
	checked?: boolean;
	expired?: boolean;
}

interface TimelineItemsProps {
	item: TimelineItemProps;
}

const TimelineItem: React.FC<TimelineItemsProps> = ({ item }) => {
	const statusColor = {
		accepted: "bg-lowOpacity",
		confirmed: "bg-greenBgColor",
		rejected: "bg-redBgColor",
		haveTo: "bg-skyBgColor",
		archieve: "bg-grayOne",
	};
	const statusTextColor = {
		accepted: "text-mainColor",
		confirmed: "text-greenColor",
		rejected: "text-redColor",
		haveTo: "text-skyColor",
		archieve: "text-textColor",
	};

	const statusText = {
		accepted: "Täze kabul edildi",
		confirmed: "Tassyklandy",
		rejected: "Ýerine ýetirilmedi",
		haveTo: "Ýerine ýetirmeli",
		archieve: "Arhiwda",
	};

	return (
		<div className="grid gap-6 grid-cols-maxFr">
			<div className="grid gap-3 grid-rows-maxFr place-items-center">
				<div
					className={`grid w-6 h-6 rounded-full ${
						item.expired ? "bg-redBgColor" : "bg-lowOpacity"
					} grid-col-1 place-content-center place-items-center`}
				>
					<div
						className={`w-3 h-3 rounded-full ${
							item.expired ? "bg-redColor" : "bg-mainColor"
						}`}
					></div>
				</div>
				<div className="w-[1.5px] h-full transform -translate-x-1/2 bg-strokeColor"></div>
			</div>

			<div className="grid grid-cols-1 gap-3 grid-rows-maxFr place-items-center">
				<P size="t1" type="regular" className="place-self-start">
					{item.date}
				</P>

				<div className="grid w-full grid-flow-row grid-cols-1 gap-3 p-3 border rounded-md border-strokeColor auto-rows-max">
					<div className="grid gap-4 grid-cols-maxTwo place-content-between place-items-center">
						<div className="grid gap-1 grid-cols-maxTwo place-items-center">
							<P size="p2" type="medium" className="text-mainColor">
								{item.person}
							</P>
							<P size="t1" type="regular">
								{item.positionName}
							</P>
						</div>
						<div className={`${statusColor[item.status]} px-3 py-1 rounded`}>
							<P
								size="t1"
								type="medium"
								className={`${statusTextColor[item.status]}`}
							>
								{statusText[item.status]}
							</P>
						</div>
					</div>

					{item.note && (
						<P size="t1" type="regular">
							{item.note}
						</P>
					)}

					{item.checked && (
						<P
							size="t1"
							type="regular"
							className="px-2 py-1 rounded-md bg-greenBgColor text-greenColor w-max"
						>
							Barlandy
						</P>
					)}

					{item.documents && item.documents.length > 0 && (
						<div className="flex flex-wrap gap-2 mt-2">
							{item.documents.map((doc, index) => (
								<div
									key={index}
									className="grid items-center grid-cols-1 px-3 py-1 rounded bg-lowOpacity"
								>
									<P size="t1" type="medium" className="text-mainColor">
										{doc}
									</P>
								</div>
							))}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default TimelineItem;
